import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthorizationBlockedComponent } from './authorization-blocked.component';

@NgModule({
    imports: [CommonModule],
    declarations: [AuthorizationBlockedComponent],
    exports: [AuthorizationBlockedComponent],
})
export class AuthorizationBlockedModule { }
